module.exports = __webpack_public_path__ + "8bbefe074290c7947b8ff725912f3908.png";